import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { searchSiret } from "./search-siret";
import type { SiretSuggestion } from "@shared-kernel/application/ports/siret-search/siret-search-repository";

const initialState: RetrievalState<SiretSuggestion[]> = { fetching: "idle", data: [] };

export const searchSiretReducer = createReducer<RetrievalState<SiretSuggestion[]>>(initialState, builder => {
  builder.addCase(searchSiret.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(searchSiret.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(searchSiret.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
